// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35MYL","newExpiryDate":"styles_newExpiryDate__1oPG5","footer":"styles_footer__VSu_7"};